module.exports = function getResource(label, vars = []) {
    let resources = {
        map: 'Map',
        moreTimesLocations: 'Show more times & locations'
    };

    return resources[label];
};
